<template>
  <v-container>
    <v-row>
      <v-col style="text-align:center">
        <img src="/assets/marketpro-logo.svg" class="logo-dark" alt="Logo Marketpro" width="250" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <login-form v-if="connectionForm" @subscribe="subscription()" @reset="reset()" />
        <subscription-form v-if="subscriptionForm" @connection="connection()" />
        <reset-password-form v-if="resetForm" @connection="connection()" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import LoginForm from "../components/login/LoginForm";
import ResetPasswordForm from "../components/login/ResetPasswordForm";
import SubscriptionForm from "../components/login/SubscriptionForm";
export default {
  components: {
    LoginForm,
    SubscriptionForm,
    ResetPasswordForm
  },
  computed: {
    ...mapGetters("auth", ["loading"])
  },
  data: function() {
    return {
      error: null,
      subscriptionForm: false,
      connectionForm: true,
      resetForm: false,
      credential: {},
      token:null
    };
  },
  mounted(){
    this.token = this.$route.query.reset_token;
    if(this.token){
      this.reset()
    }
  },
  methods: {
    connection() {
      this.connectionForm = true;
      this.subscriptionForm = false;
      this.resetForm=false;
    },
    subscription() {
      this.connectionForm = false;
      this.subscriptionForm = true;
      this.resetForm=false;
    },
    reset() {
      this.connectionForm = false;
      this.subscriptionForm = false;
      this.resetForm=true;
    }
  }
};
</script>

<style lang="less" scoped>
</style>